import PropTypes from "prop-types"
import { get } from "lodash"
import { formatIntradayHeaderDate } from "helpers/formatters/dates"
import { DATE } from "helpers/shapes"
import TooltipItem from "./item"

function AnalyzeTooltip({ datum, items, formatter, focusedChartLine, intradayChartMode = "none", hasDotClick }) {
  if (datum) {
    const headerText = formatIntradayHeaderDate(intradayChartMode, datum.date, datum.batchId)
    const focusedItem = hasDotClick && focusedChartLine ? items.find(i => i.id === focusedChartLine && !i.disabled) : null
    return <div className="components_analyze-tooltip">
      <div className="header">{headerText}</div>
      {items.map(item => !item.disabled && <TooltipItem
        key={item.id}
        value={get(datum, item.id, "--")}
        {...item}
        focused={focusedChartLine}
        formatter={formatter}
      />,
      )}
      {focusedItem && <div className="drilldown-hint">View {focusedItem.label} contributors</div>}
    </div>
  } else {
    return null
  }
}

AnalyzeTooltip.propTypes = {
  formatter: PropTypes.func,
  focusedChartLine: PropTypes.string,
  hasDotClick: PropTypes.bool,
  datum: PropTypes.shape({
    date: DATE.isRequired,
    index: PropTypes.number,
    batchId: PropTypes.string,
  }),
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  })).isRequired,
  intradayChartMode: PropTypes.oneOf(["none", "liveTick", "batchTrend"]),
}

export default AnalyzeTooltip
